import i18n from "@/i18n";
import { objCameCae } from "@/views/zhiji/js/common/util.js";
import { queryAndConvertResp, postAndConvertResp } from "@/views/zhiji/js/services/service.js";

export function getParamsList(reqData) {
    const sourceToServe = {
        all: "",
        sdk: 0,
        idip: 1,
        custom: 2
    };
    const sourceToClient = {
        0: i18n.t("zhiji.portrait.source.SDK"),
        1: i18n.t("zhiji.portrait.source.IDIP"),
        2: i18n.t("zhiji.portrait.source.CUSTOM")
    };
    const typeToServe = {
        eventName: "name",
        tableName: "table_name"
    };
    return queryAndConvertResp(
        "/xiaoyue-operation/user_profile/param/search",
        {
            source: reqData.source ? sourceToServe[reqData.source] : "",
            search_type: reqData.searchType ? typeToServe[reqData.searchType] : "",
            search_field: reqData.searchWord || "",
            page: reqData.page || "",
            size: reqData.size || ""
        },
        result => {
            const request = {
                list: result.list.map(item => ({
                    ...item,
                    remark: item.remark || "—",
                    source: item.source !== "" ? sourceToClient[item.source] : i18n.t("zhiji.portrait.source.ALL")
                })),
                total: result.count || 0
            };
            return objCameCae(request, false);
        }
    );
}

export function addParam(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/param/add",
        {
            name: reqData.name,
            describe: reqData.describe,
            type: reqData.type,
            table_name: reqData.tableName,
            source: reqData.source,
            source_value: reqData.sourceValue || "",
            remark: reqData.remark || ""
        },
        result => objCameCae(result, false)
    );
}

export function updateParam(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/param/update",
        {
            id: reqData.id,
            name: reqData.name,
            describe: reqData.describe,
            type: reqData.type,
            table_name: reqData.tableName,
            source: reqData.source,
            source_value: reqData.sourceValue || "",
            remark: reqData.remark || ""
        },
        result => objCameCae(result, false)
    );
}

export function deleteParam(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/param/delete",
        {
            ids: reqData.id
        },
        result => objCameCae(result, false)
    );
}

export function getParamById(reqData) {
    return queryAndConvertResp(
        "/xiaoyue-operation/user_profile/param/get",
        {
            id: reqData.id
        },
        result => objCameCae(result, false)
    );
}

// 获取画像标签分类列表
export function getClassList(reqData) {
    return queryAndConvertResp(
        "/xiaoyue-operation/user_profile/tag_classify/list",
        {
            name: reqData.name
        },
        result => {
            const resp = {
                count: result.count,
                list:
                    result &&
                    result.list.map(item => {
                        return {
                            ...item,
                            useType: item.use_type ? item.use_type.split(",") : []
                        };
                    })
            };
            return objCameCae(resp, false);
        }
    );
}

// 添加画像标签分类
export function addClass(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/tag_classify/add",
        {
            name: reqData.name,
            describe: reqData.describe,
            use_type: reqData.useType.join(",")
        },
        result => objCameCae(result, false)
    );
}

// 更新画像标签分类
export function updateClass(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/tag_classify/update",
        {
            id: reqData.id,
            name: reqData.name,
            describe: reqData.describe,
            use_type: reqData.useType.join(",")
        },
        result => objCameCae(result, false)
    );
}

// 删除画像标签分类
export function deleteClass(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/tag_classify/delete",
        {
            ids: reqData.id
        },
        result => objCameCae(result, false)
    );
}

// 获取画像标签列表
export function getTagParams(reqData) {
    return queryAndConvertResp(
        "/xiaoyue-operation/user_profile/tag/search",
        {
            classify_id: reqData.classId || "",
            search_type: reqData.type || "",
            search_field: reqData.word || "",
            page: reqData.page || 1,
            size: reqData.size || 10
        },
        result => objCameCae(result, false)
    );
}

// 添加画像标签
export function addTagParam(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/tag/add",
        {
            name: reqData.name,
            classify_id: reqData.classifyId,
            param_ids: reqData.paramJson.map(item => item.param_id).join(",") || "",
            param_json: JSON.stringify(reqData.paramJson) || ""
        },
        result => objCameCae(result, false)
    );
}

// 更新画像标签
export function updateTagParam(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/tag/update",
        {
            id: reqData.id,
            name: reqData.name,
            classify_id: reqData.classifyId,
            param_ids: reqData.paramJson.map(item => item.param_id).join(",") || "",
            param_json: JSON.stringify(reqData.paramJson) || ""
        },
        result => objCameCae(result, false)
    );
}

// 删除画像标签
export function deleteTagParam(reqData) {
    return postAndConvertResp(
        "/xiaoyue-operation/user_profile/tag/delete",
        {
            ids: reqData.id
        },
        result => objCameCae(result, false)
    );
}

// 获取单个画像标签
export function getTagById(reqData) {
    return queryAndConvertResp(
        "/xiaoyue-operation/user_profile/tag/get",
        {
            id: reqData.id
        },
        result => objCameCae(result, false)
    );
}
